const getBrowserPlatform = () => {
    if (typeof navigator === 'undefined') return '';
    const browserNavigator = navigator as Navigator & { userAgentData?: { platform?: string } };
    return browserNavigator.userAgentData?.platform || browserNavigator.platform || browserNavigator.userAgent;
};

export const isMacPlatform = (platform = getBrowserPlatform()) => /^mac/i.test(platform);
